import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"

import {
  faSpinner,
  faChevronRight,
  faHome,
  faLocationArrow,
  faPhoneAlt,
  faGavel,
  faUserPlus,
  faBookOpen,
  faImages,
} from "@fortawesome/free-solid-svg-icons"

library.add(
  faSpinner,
  faChevronRight,
  faHome,
  faLocationArrow,
  faPhoneAlt,
  faGavel,
  faUserPlus,
  faBookOpen,
  faImages
)

const Icon = ({ prefix, name, spin }) => {
  if (spin === true) {
    return <FontAwesomeIcon icon={[prefix, name]} spin />
  } else {
    return <FontAwesomeIcon icon={[prefix, name]} />
  }
}

export default Icon
